import axios, { AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import { store } from '../redux/store';
import { clearUserDetails } from '../redux/userDetails/userSlice';
import { configs } from '../constants/configs';

const STATUS_CODES = {
  UNAUTHORIZED_401: 401,
  UNAUTHORIZED_403: 403,
  INTERNAl_SERVER_ERROR_500: 500,
};

const BASE_URL = configs.VITE_APP_BASE_URL;

const logout = async () => {
  try {
    await axios.post('/moo/auth/v1/logout', {});
  } catch (error) {
    console.error({ message: 'logout failed', error });
  }
};

// Create axios instance
export const axiosInstance = axios.create({
  withCredentials: true,
  baseURL: BASE_URL,
});

// Request interceptor
axiosInstance.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    return config;
  },
  (error) => {
    return Promise.reject(error instanceof Error ? error : new Error(String(error)));
  },
);

const handleLogOut = async ({ clearStore }: { clearStore: boolean }) => {
  sessionStorage.clear();
  localStorage.clear();
  try {
    await logout();
    // clear redux store
    store.dispatch(clearUserDetails());
    if (clearStore) {
      store.dispatch({ type: 'clear/clearResults' });
    }
  } catch (error) {
    console.error({ message: 'logout failed', error });
  }
};

// Response interceptor
axiosInstance.interceptors.response.use(
  (response: AxiosResponse) => {
    if (
      response?.status === STATUS_CODES.UNAUTHORIZED_401 ||
      response?.status === STATUS_CODES.UNAUTHORIZED_403
    ) {
      handleLogOut({ clearStore: true });
    }
    return response;
  },
  (error) => {
    const responseStatusCode = error?.response?.status;

    if (
      responseStatusCode === STATUS_CODES.UNAUTHORIZED_401 ||
      responseStatusCode === STATUS_CODES.UNAUTHORIZED_403
    ) {
      handleLogOut({ clearStore: true });
    }
    return Promise.reject(error instanceof Error ? error : new Error(String(error)));
  },
);

interface ICustomBaseQuery {
  url: string;
  method: string;
  params?: Record<string, unknown>;
  body?: Record<string, unknown>;
}

export const customBaseQuery = async ({ url, method, params, body }: ICustomBaseQuery) => {
  try {
    let result;

    if (method?.toUpperCase() === 'GET') {
      result = await axiosInstance({ url, method, params });
    } else {
      result = await axiosInstance({ url, method, data: body });
    }

    return { data: result.data };
  } catch (error) {
    return { error };
  }
};
